import type { IndustryPoint, MacroExposureGroup } from "./api/macro-exposure";

/**
 * Owned NI by industry name, matched ignoring case, set as each point's volume. An industry with no match keeps
 * volume 0, and no volumes at all (not loaded yet, or the request failed) leaves the points as they are.
 *
 * Shared by the Macro Exposure page's bubble charts and the Watchlist's borrower list, so both read the same
 * net investment for an industry.
 */
export function withVolumes(
  group: MacroExposureGroup,
  volumes: Record<string, number> | undefined,
): IndustryPoint[] {
  if (!volumes) return group.points;
  const byName = new Map(Object.entries(volumes).map(([k, v]) => [k.trim().toLowerCase(), v]));
  return group.points.map((p) => ({ ...p, volume: byName.get(p.name.trim().toLowerCase()) ?? 0 }));
}
